import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'zui-logo-full',
  templateUrl: './logo-full.component.html',
  styleUrls: [ './logo-full.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoFullComponent {

}
